var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('v-row', [_c('v-col', [_c('v-text-field', _vm._b({
    attrs: {
      "label": "학교"
    },
    model: {
      value: _vm.inputData.affiliation,
      callback: function callback($$v) {
        _vm.$set(_vm.inputData, "affiliation", $$v);
      },
      expression: "inputData.affiliation"
    }
  }, 'v-text-field', _vm.inputProps, false))], 1), _c('v-col', [_c('v-text-field', _vm._b({
    attrs: {
      "label": "학과"
    },
    model: {
      value: _vm.inputData.department,
      callback: function callback($$v) {
        _vm.$set(_vm.inputData, "department", $$v);
      },
      expression: "inputData.department"
    }
  }, 'v-text-field', _vm.inputProps, false))], 1)], 1);
}
var staticRenderFns = []

export { render, staticRenderFns }